import React from 'react';

import { reduxHooks } from 'hooks';

import './index.scss';

/**
 * Nav bar rendering one entry per nav item (product categories, direct
 * categories, and an "others" entry when present). Clicking an entry
 * selects it as the current nav item.
 */
export const LearnerDashboardNav = () => {
  const navItems = reduxHooks.useNavItems();
  const selectedNavItem = reduxHooks.useSelectedNavItem();
  const selectNavItem = reduxHooks.useSelectNavItem();

  return (
    <nav className="learner-dashboard-nav d-flex flex-wrap" aria-label="Learner Dashboard Navigation">
      {navItems.map((item) => {
        const isSelected = !!selectedNavItem
          && selectedNavItem.type === item.type
          && selectedNavItem.slug === item.slug;
        return (
          <button
            key={`${item.type}-${item.slug}`}
            type="button"
            className={`learner-dashboard-nav-item btn btn-link ${isSelected ? 'active' : ''}`}
            aria-current={isSelected}
            onClick={() => selectNavItem({ type: item.type, slug: item.slug })}
          >
            {item.title}
          </button>
        );
      })}
    </nav>
  );
};

export default LearnerDashboardNav;
